import { Button } from "antd";
import { FC, useState } from "react";
import Icon from "../../../assets/icons/icon";
import { renderErrorMessage } from "../../../components/messages/errorMessage";
import LeasingStore from "../../../contexts/leasingStore";
import _t from "../../../lang/translate";
import { downloadChecklistUrl } from "../../../services/leasingService";
import { openFileLink } from "../../../services/mediaService";
import PopoverList from "../../../components/popups/popoverList";

const LeasingGenerateChecklist: FC = () => {
  const { leasingCase } = LeasingStore.useContainer();
  const [loading, setLoading] = useState<boolean>(false);

  const handleChecklistDownload = async () => {
    try {
      setLoading(true);
      await openFileLink(downloadChecklistUrl(leasingCase.id));
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setLoading(false);
    }
  };

  const disabled = !leasingCase.flags.validationStarted;

  return (
    <PopoverList list={[
      !leasingCase.flags.validationStarted ? "Påbegynd validering først" : null,
    ].filter(Boolean) as string[]}>
      <Button loading={loading} disabled={disabled} onClick={handleChecklistDownload}>
        <Icon name="download-outline" size="large" /> {_t("checklist")}
      </Button>
    </PopoverList>
  );
};

export default LeasingGenerateChecklist;
